<p-card class="p-card container">
  <h3 i18n>Mes documents</h3>

  <p-treeTable [value]="tableContent">
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
      <tr [ttRow]="rowNode">
        <td>
          @if ((!rowData.fileName && rowData.isPdf) || (!rowData.href && rowData.isUrl)) {
            <span>
              <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
              <span>{{ rowData.name }}</span>
            </span>
          }
          @if (rowData.fileName && rowData.isPdf) {
            <span class="row__name" (click)="openPdf(rowData.fileName)">
              @if (rowData.isPdf) {
                <span class="pi pi-file-pdf">&nbsp;</span>
              }
              <u>{{ rowData.name }}&nbsp;</u>
              <span class="pi pi-external-link"></span>
            </span>
          }
          @if (rowData.href && rowData.isUrl) {
            <span class="row__name" (click)="openWebsite(rowData.href)">
              @if (rowData.isUrl) {
                <span class="pi pi-globe">&nbsp;</span>
              }
              <u>{{ rowData.name }}&nbsp;</u>
              <span class="pi pi-external-link"></span>
            </span>
          }
        </td>
      </tr>
    </ng-template>
  </p-treeTable>
</p-card>
